import { Pipe, PipeTransform } from '@angular/core';
import { IndexableContentType, SearchResultCmsPageViewModel } from '@models/api.models';

@Pipe({
    name: 'getByContentType',
    standalone: true
})
export class GetByContentTypePipe implements PipeTransform {
    transform(
        contentResults: SearchResultCmsPageViewModel[],
        ...types: IndexableContentType[]
    ): SearchResultCmsPageViewModel[] {
        return types
            .map(type => contentResults.filter(result => result.contentType?.toLowerCase() === type.toLowerCase()))
            .flat();
    }
}
